import { z } from 'zod';

import { NOTE_TYPES } from '@/modules/notes/constants';

export const noteFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, 'Informe o título')
    .transform((title) => title.toUpperCase()),
  content: z
    .string()
    .trim()
    .min(1, 'Informe o conteúdo')
    .transform((content) => content.toUpperCase()),
  type: z.enum(NOTE_TYPES, {
    errorMap: () => ({ message: 'Selecione o tipo da observação' }),
  }),
});

export type NoteFormData = z.infer<typeof noteFormSchema>;
